import React from 'react'
import styles from '../Proj5Folder/Proj5.module.css'
import clinic1 from '../../Images/clinic1.jpeg'
import clinic2 from '../../Images/clinic2.jpeg'
import clinic3 from '../../Images/clinic3.jpeg'
import clinic4 from '../../Images/clinic4.jpeg'







export default function HealthInsuranceClinics() {
  return (

    <>
        <div className="container my-5 py-5 ">
          <div className="row align-items-center">
            <div className="col-md-6">
                <h3 className={`${styles.color} my-3`}> Health Insurance Clinics in Damietta  ​</h3>
                <p> Project description: Hospital Building  </p>
                <p>Type of contract: Design and supervision </p>
                <p>Type of works : Architectural and Electromechanical </p>
            </div>
            <div className="col-md-6">
                <img src={clinic1} alt="achegy" className='img-fluid'/>
            </div>   
          </div>
          <div className="row my-5 pb-5">
          <div className="col-md-4 my-1 text-center">
               <img src={clinic2} alt="achegy" className={`${styles.imgSizeProj}`}/> 
            </div>
            <div className="col-md-4 my-2 text-center">
               <img src={clinic3} alt="achegy" className={`${styles.imgSizeProj}`}/> 
            </div>
                   <div className="col-md-4 my-2 text-center">
               <img src={clinic4} alt="achegy" className={`${styles.imgSizeProj}`}/> 
            </div>
           
         
        
          
          </div>

        </div> 

    </>
  )
}
